import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTextAlignmentLeft12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconTextAlignmentLeft12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M1.5 4a.5.5 0 0 1 0-1h9a.5.5 0 0 1 0 1zm0 2a.5.5 0 0 1 0-1H9a.5.5 0 0 1 0 1zM1 9.5a.5.5 0 0 0 .5.5H9a.5.5 0 0 0 0-1H1.5a.5.5 0 0 0-.5.5M1.5 8a.5.5 0 0 1 0-1h9a.5.5 0 0 1 0 1z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTextAlignmentLeft12);
